import moment from "moment-timezone";
import "moment/locale/es";

let defaultTimezone: string | null = null;

function setTimezone(timezone: string) {
  const trimmed = timezone?.trim();
  if (!trimmed) return;
  defaultTimezone = trimmed;
  moment.tz.setDefault(trimmed);
}

/** Company timezone from login (`setTimezone`); falls back to browser guess. */
function getTimezone(): string {
  return defaultTimezone ?? moment.tz.guess();
}

/** Prefer explicit company IANA zone when provided (e.g. `America/Los_Angeles`). */
function resolveTimezone(companyTimezone?: string | null): string {
  const fromCompany = companyTimezone?.trim();
  if (fromCompany) return fromCompany;
  return getTimezone();
}

export {getTimezone, moment, resolveTimezone, setTimezone};
